
import React, { useState } from "react";
import "./AdminLogin.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { adminLogin } from "../api/admin";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const AdminLogin = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const updateField = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ===============================
  // ADMIN LOGIN
  // ===============================
  const handleAdminLogin = async (e) => {
    e.preventDefault();

    try {
      console.log("🚀 SENDING LOGIN REQUEST:", { username: form.username, password: " (hidden)" });
      const res = await adminLogin({
        username: form.username,
        password: form.password,
      });

      console.log("✅ LOGIN SUCCESS:", res.data);
      const { access_token, token, admin } = res.data;
      const finalToken = access_token || token;

      // 🔐 Save admin details
      localStorage.setItem("adminToken", finalToken);
      localStorage.setItem("adminName", admin?.name || admin?.username || "Admin");
      localStorage.setItem("adminRole", admin?.role || "admin");
      localStorage.setItem("adminPermissions", JSON.stringify(admin?.permissions || []));

      if (admin?.role === "subadmin") {
        toast.success("Subadmin login successful");
      } else {
        toast.success("Admin login successful");
      }

      setTimeout(() => {
        navigate("/adminDashboard");
      }, 1500);
    } catch (err) {
      console.log("❌ LOGIN FAILED");
      console.log("Full Error Object:", err);
      console.log("Response Data:", err.response?.data);
      console.log("Response Status:", err.response?.status);

      const serverMessage = err.response?.data?.message || err.response?.data?.error || JSON.stringify(err.response?.data);
      const errorMessage = serverMessage || "Invalid credentials or server error. Please check your username and password.";

      toast.error(`Error: ${errorMessage}`);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Admin Login</h2>
        <p className="subtitle">Sign in to admin panel</p>

        <form onSubmit={handleAdminLogin}>
          <div style={{ position: "relative", width: "100%", marginBottom: "16px" }}>
            <input
              name="username"
              placeholder="Username*"
              className="auth-input"
              style={{ marginBottom: 0, width: "100%" }}
              onChange={updateField}
              required
            />
          </div>

          <div className="password-wrapper">
            <input
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Password*"
              className="auth-input password-input"
              onChange={updateField}
              required
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button className="btn" type="submit">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;

